import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

export async function getInvoicePdf(payload, fileName = "file.pdf") {
  try {
    const res = await axiosInstance.post(
      `${API_URL}/sales-invoice/print-pdf`,
      payload,
      {
        responseType: "blob",
      },
    );
    if (res.status === 200 && res.data) {
      const blob = new Blob([res.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
    }
  } catch (error) {
    console.error(error);
    throw new Error(error?.response?.data?.message || error?.message);
  }
}

export const fetchExportInvoiceApi = async (modId, payload) => {
  return await axiosInstance.post(
    `${API_URL}/sales-invoice/export/${modId}`,
    payload,
  );
};
